


































import { Component, Vue } from "vue-property-decorator";
import { mapGetters, mapMutations } from "vuex";
import { User } from "@/models/definitions";

@Component({
  computed: mapGetters(["allUsers", "currentUser"]),
  methods: mapMutations(["setCurrentUserId"]),
})
export default class TheNavbar extends Vue {
  private displayName(user: User): string {
    if (!user) {
      return "<undefined>";
    }

    if (user.nick_name) {
      return user.nick_name;
    } else if (user.first_name) {
      return user.first_name;
    } else if (user.last_name) {
      return user.last_name;
    } else {
      return String(user.id);
    }
  }
}
